import { useState } from "react";
import { AppPTORequests } from "../app-time-off/AppPTORequests";
import { AppTimeOff } from "../app-time-off/AppTimeOff";
import { AppTimeOffRequest } from "../app-time-off/AppTimeOffRequest";

type DCPTORequestData = {
    employeeRecordIds: string[] | undefined; 
}

type DCPTORequestProps = {
    data: DCPTORequestData;
    balanceOnly?: boolean; // Optional prop to indicate if it's for balance only
} 

 export const DCPTORequest = ({data, balanceOnly = false}: DCPTORequestProps) => {
    return (
        <>
            <AppTimeOffRequest 
                dynamicContext={{employeeRecordIds: data.employeeRecordIds}} 
                balanceOnly={balanceOnly}
            /> 
        </>
    )
}
